import React from "react";
import App from "../App";
import MobileApp from "../mobile/MobileApp";
import { useIsMobile } from "../mobile/useIsMobile";
import Login from "../pages/Login";
import { useAuth } from "./AuthContext";
import { SettingsProvider } from "../settings/SettingsContext";

// Shows the login screen until signed in. The app (and its settings, which
// need the server) only mounts once there is a valid session.
const AuthGate = () => {
  const { isAuthenticated } = useAuth();
  const isMobile = useIsMobile();

  if (!isAuthenticated) return <Login />;

  return (
    <SettingsProvider>
      {isMobile ? <MobileApp /> : <App />}
    </SettingsProvider>
  );
};

export default AuthGate;
